/**
 * Utilities for extracting and processing content from various types
 */

/**
 * Extracts plain text from React content (string, number, or ReactNode)
 * @param content - The content to extract text from
 * @returns Plain text string or empty string if not extractable
 */
export const nodeToString = (content: React.ReactNode | string): string => {
  if (typeof content === 'string') {
    return content;
  }

  if (typeof content === 'number') {
    return String(content);
  }

  return '';
};
